module.exports = __webpack_public_path__ + "assets/dashboard-empty.74ac5e86.svg";